import { useContext } from 'react';
import { SmartSendItemsCache } from '../../lib/cache/SmartSendItemsCache';
import { SmartSendContext } from '../../lib/context/SmartSendContext';
import { GetSelectionBasedOnAction } from '../../lib/helpers/GetSelectionBasedOnAction';
import SetMarketplaceAction from '../smartsend/item/SetMarketplaceAction';
import { PickingListAndPrintButton } from '../warehouse/pickinglist/PickingListAndPrintButton';

interface props {
  filterKey: string;
  onClose: () => void;
}

const DownloadPickingListTask: React.FC<props> = (props) => {
  const sctx = useContext(SmartSendContext);
  return (
    <PickingListAndPrintButton
      items={GetSelectionBasedOnAction(props.filterKey, sctx.state, 'Download:PickingList', SmartSendItemsCache)}
      action={(type, id) => {
        SetMarketplaceAction(sctx.dispatch, id, type);
      }}
    />
  );
};

export default DownloadPickingListTask;
